import _styled from "@emotion/styled-base";
import { themed, mapComponentThemes } from "../themes";
import { overflowContainerWithShadowsTheme } from "./themes";
import { getScrollerStyles } from "./styled";
import OverflowContainer from "./OverflowContainer"; // NOTE: These components cannot live in styled.js due to circular dependency
// issues with OverflowContainer

var ThemedOverflowContainer = themed(OverflowContainer)(function (_ref) {
  var baseTheme = _ref.theme;
  return mapComponentThemes({
    name: 'OverflowContainerWithShadows',
    theme: overflowContainerWithShadowsTheme(baseTheme)
  }, {
    name: 'OverflowContainer',
    theme: {}
  }, baseTheme);
});
export default
/*#__PURE__*/
_styled(ThemedOverflowContainer, {
  target: "e5t3hk80"
})(getScrollerStyles);